import React, { Component } from 'react'
import aboutvision1 from '../../images/aboutvision1.png'
import aboutvision2 from '../../images/aboutvision2.png'
import aboutvision3 from '../../images/aboutvision3.png'
import SectionHeader from './SectionHeader'
import Card1 from '../cards/Card1'
import Card6 from '../cards/Card6'

export class VisionAU extends Component {
    render() {
        const { className } = this.props;
        return (
            <div className={`${className} p-[52px_0px] mt-[32px]`}>
                <div className='container grid grid-cols-2 items-start gap-[32px] max-[880px]:grid-cols-1 max-[500px]:gap-[7px] '>

                    <div className='flex flex-col gap-[20px] max-[880px]:items-center  '>
                        <img src={aboutvision1} className='rounded-[8px] w-full  max-[880px]:w-[75%] max-[620px]:w-full' />

                        <div className='grid grid-cols-2 gap-[20px] max-[880px]:w-[75%] max-[620px]:w-full max-[500px]:grid-cols-1'>
                            <img src={aboutvision2} className=' w-full rounded-[8px] ' />
                            <img src={aboutvision3} className=' w-full rounded-[8px] ' />
                        </div>
                    </div>

                    <div className='flex flex-col max-[480px]:p-[20px] '>
                        <div className='flex flex-col gap-[15px] items-start max-[1060px]:gap-[8px]'>
                            <span className='text-[var(--orange)]'>Vizyonumuz</span>

                            <SectionHeader title="Gələcəyin Texnologiyalarını Bu Gün Yaradın" className="max-w-[80%]" />
                        </div>

                        <div className='flex flex-col gap-[15px] mt-[15px] max-[1020px]:gap-[12px]'>
                            <p className='font-[400] text-[18px] text-[#555] max-[700px]:text-[16px] max-[400px]:text-[15px]'>
                                Bizim vizyonumuz, müştərilərimizə texnologiyanın gücündən maksimum istifadə etməyə imkan verən rəqəmsal həlləri təmin etməkdir. Gələcək texnologiyalara öncülük edərək, müştərilərimizin işlərini rəqabətcil və davamlı şəkildə inkişaf etdirmələrinə dəstək oluruq.
                            </p>
                            <p className='font-[400] text-[18px] text-[#555] max-[700px]:text-[16px] max-[400px]:text-[15px]'>
                                ITnova olaraq, texnoloji yenilikləri daim izləyir və müştərilərimizə dünya səviyyəli xidmətlər təqdim edirik. Hədəfimiz, müştərilərimizin hər zaman bir addım öndə olmasını təmin etmək və rəqəmsal dünyada onların uğurlarını zirvəyə daşımaqdır.
                            </p>

                            {/* 
                            <Card6 />
                            <Card6 />
                            <Card6 /> */}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default VisionAU